import styled from 'styled-components';

export const SearchBarWrapper = styled.div`
  position: relative;
  max-width: 45rem;
  margin: 0 auto ${({ theme }) => theme.spacing[6]};

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: ${({ theme }) => theme.spacing[5]};
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.gray400};
  pointer-events: none;
  display: flex;
  align-items: center;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[5]};
  padding-left: ${({ theme }) => theme.spacing[12]};
  font-size: ${({ theme }) => theme.fontSizes.md};
  border: 2px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radii.full};
  background-color: ${({ theme }) => theme.colors.bgSurface};
  transition: all ${({ theme }) => theme.transitions.base};
  box-shadow: ${({ theme }) => theme.shadows.sm};

  &:focus {
    border-color: ${({ theme }) => theme.colors.accent};
    box-shadow: 0 0 0 3px rgba(212, 168, 67, 0.15), ${({ theme }) => theme.shadows.md};
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray400};
  }
`;

export const SubmitButton = styled.button`
  position: absolute;
  right: ${({ theme }) => theme.spacing[2]};
  top: 50%;
  transform: translateY(-50%);
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[5]}`};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.textInverse};
  border: none;
  border-radius: ${({ theme }) => theme.radii.full};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  cursor: pointer;
  transition: background-color ${({ theme }) => theme.transitions.fast};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryLight};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const HistoryItem = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray100};
  cursor: pointer;
  transition: background-color ${({ theme }) => theme.transitions.fast};
  width: 100%;
  background: transparent;
  text-align: start;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary50};
  }
`;

export const HistoryQuery = styled.span`
  flex: 1;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HistoryCount = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
`;
